<div class="flex justify-center">
  <div
    class="relative flex items-center bg-white dark:bg-gray-800
            rounded-full shadow-[0_2px_8px_rgba(0,0,0,0.08)] dark:shadow-[0_2px_8px_rgba(0,0,0,0.4)]
            transition-all duration-500 ease-out overflow-hidden"
    [ngClass]="isExpanded ? 'w-[250px] h-11' : 'w-10 h-10'"
  >
    <!-- Input -->
    <input
      type="text"
      [placeholder]="placeholder"
      [formControl]="searchControl"
      (focus)="expandSearch()"
      (blur)="collapseSearch()"
      class="w-full bg-transparent text-gray-900 dark:text-white
             placeholder-gray-500 dark:placeholder-gray-400
             outline-none px-4 text-sm transition-opacity duration-400"
      [ngClass]="isExpanded ? 'opacity-100' : 'opacity-0'"
    />
    <button
      *ngIf="searchControl.value"
      type="button"
      (click)="clearSearch($event)"
      class="absolute right-10 top-1/2 -translate-y-1/2
             flex items-center justify-center text-gray-800 dark:text-white
             hover:text-red-500 transition-colors duration-200 cursor-pointer"
    >
      <span class="material-symbols-outlined !text-[18px]">close</span>
    </button>

    <!-- Search Button -->
    <button
      type="button"
      (click)="expandSearch()"
      class="absolute right-1 top-1/2 -translate-y-1/2
             flex items-center justify-center
             bg-blue-600 text-white rounded-full
             w-8 h-8 shadow-[0_2px_4px_rgba(0,0,0,0.15)] hover:bg-blue-700 active:scale-95
             transition-all duration-300 z-10 cursor-pointer"
    >
      <span class="material-symbols-outlined text-[20px]">search</span>
    </button>
  </div>
</div>
